import Decimal from 'decimal.js';
import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import TemplateContract from './TemplateContract';

export const aggregateUnlockedHoldings = (holdings: TemplateContract<Holding>[]) => {
  if (holdings.length === 0) {
    return [];
  }
  const aggregatedUnlockedMap = new Map<string, TemplateContract<Holding>>();
  const lockedHoldings: TemplateContract<Holding>[] = [];

  holdings.forEach((holding) => {
    if (holding.payload.lock) {
      // If a lock exists, add the holding to the locked array
      lockedHoldings.push(holding);
    } else {
      // If no lock, aggregate it
      const instrumentId = holding.payload.instrument.id;
      const registrar = holding.payload.instrument.source;
      const key = `{${instrumentId.length}-${instrumentId}\0#${registrar.length}-${registrar}\0#${holding.payload.owner}`;

      const existingHolding = aggregatedUnlockedMap.get(key);

      if (existingHolding) {
        // Aggregate amount if an unlocked holding already exists
        const holdingAmount = new Decimal(holding.payload.amount);
        const existingHoldingAmount = new Decimal(existingHolding.payload.amount);
        const newTotal = holdingAmount.plus(existingHoldingAmount);
        existingHolding.payload.amount = `${newTotal.toFixed()}`;
      } else {
        // Add the first instance of a new unlocked holding
        aggregatedUnlockedMap.set(key, {
          ...holding,
          payload: { ...holding.payload, instrument: { ...holding.payload.instrument } },
        });
      }
    }
  });
  // Combine the aggregated unlocked holdings with the separate locked holdings
  const aggregatedUnlockedArray = Array.from(aggregatedUnlockedMap.values());
  return [...aggregatedUnlockedArray, ...lockedHoldings];
};
